import React, {
    useState, useEffect, useRef,
} from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import exact from 'prop-types-exact';
import A1GA from '../../../helpers/A1GA';
import Button from '../../../common/button/Button';

let searchDebounceHandle;
const SearchForm = (props) => {
    const [currentSearch, setCurrentSearch] = useState(props.initialSearch || '');
    const [suggestions, setSuggestions] = useState(false);
    const [hasSuggestions, setHasSuggestions] = useState(false);
    const [waitingForSuggestions, setWaitingForSuggestions] = useState(false);
    const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(false);
    const [activeSuggestionLink, setActiveSuggestionLink] = useState(false);
    const debouncingTime = 500;
    const inputRef = useRef();
    const history = useHistory();

    function _handleSearch(event) {
        event?.preventDefault();

        props.setModalSearchBoxState(false);

        const searchText = event?.target?.searchText?.value;

        history.push(`/busca?q=${searchText}`);

        // clear the suggestions
        setSuggestions(false);

        setWaitingForSuggestions(false);

        // @TODO close the mobile menu, if it is open. (Maybe already when opening the search box from within the mobile menu?!)
    }

    function _getSuggestions(searchString) {
        // make a request to the google api and show results as suggestions
        const apiUrl = 'https://www.googleapis.com/customsearch/v1';
        const parameters = {
            key: 'AIzaSyChaqiwYdMNpISLFDQoIV1dUqhHE7OiSs0', // custom search engine key - restricted to antena1.com.br, a1dev1.antena1.com.br, a1dev2.antena1.com.br and localhost:3000
            // note: I decided to NOT route the requests through the server because if someone wants to hurt us (by doing many requests which would cost us money) it could be done via our api as well. (even with sucuris cache and stuff, as it is possible to change the query parameters)
            // note2: I restricted the requests to be caped at 1000 per day. If this limit is hit frequently we need to check if it is regular traffic or not and maybe increase the limit...
            cx: '016811436202189383163:ha8tfvnddec',
            q: searchString,
            fields: 'items(htmlTitle, link)', // get only the title and the link of the results (this is faster https://developers.google.com/custom-search/v1/performance.html#partial)
            num: 10, // 10 is the max and seams to be the default
        };

        axios.get(apiUrl, { params: parameters })
            .then((response) => {
                let suggestionsSup = [{ title: 'Sem sugestões', link: false }]; // default if no results were returned

                if (response.data.items) {
                    suggestionsSup = response.data.items.map((item) => ({
                        htmlTitle: item.htmlTitle.split('| Antena 1')[0], // remove the "| Antena 1" part (note, if the search pattern is present in the Antena 1 part, this is not working, ex. | <b>Antena</b> 1)
                        link: item.link.split('https://www.antena1.com.br')[1], // all links come with our url included
                    }));
                }

                setSuggestions(suggestionsSup);

                setHasSuggestions(!!response.data.items);

                setWaitingForSuggestions(false);
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error('error in CSE', error);

                setSuggestions(false);

                setHasSuggestions(false);

                setWaitingForSuggestions(false);
            });
    }

    function _handleChange(event) {
        const searchString = event?.target?.value;

        setCurrentSearch(searchString);

        setWaitingForSuggestions(true);

        clearTimeout(searchDebounceHandle);

        if (searchString === '') {
            // reset the suggestions field

            setSuggestions(false);

            setWaitingForSuggestions(false);
        } else {
            // schedule the suggestion search
            searchDebounceHandle = setTimeout(() => _getSuggestions(searchString), debouncingTime);
        }
    }

    function _onSuggestionHover(index, event, link) {
        setActiveSuggestionIndex(index);

        setActiveSuggestionLink(link);
    }

    function _onSuggestionHoverOut() {
        setActiveSuggestionIndex(false);

        setActiveSuggestionLink(false);
    }

    function _onSuggestionClick(event, link) {
        // this can either be from a mouse click or on enter key
        event.preventDefault();

        A1GA.event({
            category: 'CustomSearch',
            action: 'suggestion_clicked',
            label: `searchTerm:${currentSearch}, linkClicked:${link}`,
        });

        // close the modal and open the link
        props.setModalSearchBoxState(false);

        history.push(link);
    }


    function _renderSuggestionItem(index, item) {
        const title = item.htmlTitle || item.title;
        const className = index === activeSuggestionIndex ? 'search-suggestions-item-highlighted' : '';

        if (item.link) {
            /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, react/no-danger */
            return <li
                key={`search-suggestions-item-${index}`}
                className={className}
                onMouseOver={(event) => _onSuggestionHover(index, event, item.link)}
                onFocus={(event) => _onSuggestionHover(index, event, item.link)}
                onMouseOut={_onSuggestionHoverOut}
                onBlur={_onSuggestionHoverOut}
                onClick={(e) => _onSuggestionClick(e, item.link)}
                dangerouslySetInnerHTML={{ __html: title }}
            />;
            /* eslint-enable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions, react/no-danger */
        }

        return (
            <li key={`search-suggestions-item-${index}`}>
                {title}
            </li>
        );
    }

    function _keyboardListener(event) {
        if (currentSearch || hasSuggestions || !waitingForSuggestions) {
            const currentActiveSuggestionIndex = activeSuggestionIndex;

            if (event.keyCode === 38) {
                // up key
                if (!currentActiveSuggestionIndex) {
                    // note, 0 is falsy!
                    setActiveSuggestionIndex(false);

                    setActiveSuggestionLink(false);
                } else {
                    setActiveSuggestionLink(() => suggestions[activeSuggestionIndex - 1].link);

                    setActiveSuggestionIndex((prev) => prev - 1);
                }
            } else if (event.keyCode === 40) {
                // down key
                if (currentActiveSuggestionIndex === false) {
                    setActiveSuggestionIndex(0);

                    setActiveSuggestionLink(suggestions[0].link);
                } else if (currentActiveSuggestionIndex !== suggestions.length - 1) {
                    setActiveSuggestionLink(suggestions[activeSuggestionIndex + 1].link);

                    setActiveSuggestionIndex((prev) => prev + 1);
                }
            } else if (event.keyCode === 13 && activeSuggestionLink) {
                // enter key
                _onSuggestionClick(event, activeSuggestionLink);
            }
        }

        document.body.style.overflow = 'auto';
    }

    function _showSearchTextModal() {
        // THE FUNCTION SHOW A SEARCHBOX MODAL JUST IN CELLPHONES
        // JUST IF MODAL IS NOT OPEN
        const breakpoint = props.breakpoint;
        const isMobile = breakpoint && (breakpoint.isSmall || breakpoint.isExtraSmall);

        if (!props.modalSearchBoxIsOpen && isMobile) {
            props.setModalSearchBoxState(true);
        }
    }

    useEffect(() => {
        inputRef.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="search-input">
            <form key="search-form" className="search-input-form" onSubmit={_handleSearch} autoComplete="off">
                <input
                    ref={inputRef}
                    onClick={_showSearchTextModal}
                    onChange={_handleChange}
                    onKeyDown={_keyboardListener}
                    className="search-input-form-input"
                    name="searchText"
                    placeholder="Pesquisar"
                    type="text"
                    value={currentSearch}
                />
                <Button className="Button nav-link search-input-button" title="Pesquisar">
                    <svg width="30" height="30" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.8086 17.8844L14.7208 13.7974C15.9056 12.3749 16.4964 10.5505 16.3703 8.70351C16.2442 6.85656 15.4109 5.12931 14.0437 3.8811C12.6766 2.63288 10.8808 1.9598 9.03006 2.00186C7.17928 2.04392 5.41597 2.79789 4.10693 4.10693C2.79789 5.41597 2.04392 7.17928 2.00186 9.03006C1.9598 10.8808 2.63288 12.6766 3.8811 14.0437C5.12931 15.4109 6.85656 16.2442 8.70351 16.3703C10.5505 16.4964 12.3749 15.9056 13.7974 14.7208L17.8844 18.8086C17.9451 18.8693 18.0171 18.9174 18.0964 18.9503C18.1757 18.9831 18.2607 19 18.3465 19C18.4323 19 18.5173 18.9831 18.5966 18.9503C18.6759 18.9174 18.7479 18.8693 18.8086 18.8086C18.8693 18.7479 18.9174 18.6759 18.9503 18.5966C18.9831 18.5173 19 18.4323 19 18.3465C19 18.2607 18.9831 18.1757 18.9503 18.0964C18.9174 18.0171 18.8693 17.9451 18.8086 17.8844ZM3.32432 9.20256C3.32432 8.03996 3.66907 6.90346 4.31498 5.93679C4.96089 4.97012 5.87895 4.21669 6.95306 3.77178C8.02717 3.32687 9.20909 3.21046 10.3494 3.43727C11.4896 3.66408 12.537 4.22393 13.3591 5.04602C14.1812 5.86811 14.741 6.91551 14.9679 8.05578C15.1947 9.19604 15.0783 10.378 14.6334 11.4521C14.1884 12.5262 13.435 13.4442 12.4683 14.0901C11.5017 14.7361 10.3652 15.0808 9.20256 15.0808C7.64409 15.0791 6.14994 14.4592 5.04793 13.3572C3.94592 12.2552 3.32605 10.761 3.32432 9.20256Z" fill="#777C86" />
                    </svg>
                </Button>
            </form>
            {(suggestions || waitingForSuggestions) &&
            <div className={`search-input-suggestions${props.isModal ? ' isModal' : ''}`} style={{ zIndex: 10 }}>
                {waitingForSuggestions && <div key="search-suggestions-item-loading" className="search-input-suggestions-loading" />}
                <ul key="search-suggestions" className="search-input-suggestions-ul">
                    {(suggestions && suggestions.length > 0) && suggestions.map((item, index) => _renderSuggestionItem(index, item))}
                </ul>
            </div>}
        </div>
    );
};

SearchForm.propTypes = exact({
    breakpoint: PropTypes.object,
    setModalSearchBoxState: PropTypes.func.isRequired,
    modalSearchBoxIsOpen: PropTypes.bool,
    initialSearch: PropTypes.string,
    isModal: PropTypes.string,
});

export default SearchForm;
